export default __webpack_public_path__ + "static/media/9.b0538585.jpg";